import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

const FormField = props => {
  const { label, type, error } = props;

  let className = `input ${error ? "is-danger" : ""}`;
  if (type === "checkbox") {
    className = "";
  }

  const inputProps = { ...props };
  delete inputProps.error;

  return (
    <div className="control">
      <label className="label">
        {label}
        <Field placeholder={label} className={className} {...inputProps} />
        {Boolean(error) && <span className="help is-danger">{error}</span>}
      </label>
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  type: PropTypes.string,
  error: PropTypes.string
};

export default FormField;



/** WEBPACK FOOTER **
 ** ./src/components/FormField.jsx
 **/